import YkcDatePicker from './src/ykc-date-picker.vue';

YkcDatePicker.install = function install(_vue) {
  _vue.component(YkcDatePicker.name, YkcDatePicker);
};
export default YkcDatePicker;
